import {FIELD_TYPE} from "types/enums";
const {INPUT} = FIELD_TYPE;
const css = {xs: 24, sm: 24, md: 24, lg: 12, xl: 12};
const fields = [
  {key: "name", name: "name", label: "Tên", type: INPUT, css: css},
  {
    key: "soTaiKhoan",
    name: "soTaiKhoan",
    label: "Số tài khoản",
    type: INPUT,
    css: css,
  },
  {
    key: "nganHang",
    name: "nganHang",
    label: "Ngân hàng",
    type: INPUT,
    css: css,
  },
  {
    key: "maSoThue",
    name: "maSoThue",
    label: "Mã số thuế",
    type: INPUT,
    css: css,
  },
  {key: "diaChi", name: "diaChi", label: "Địa chỉ", type: INPUT, css: css},
  {
    key: "soDienThoai",
    name: "soDienThoai",
    label: "Số điện thoại",
    type: INPUT,
    css: css,
  },
  {key: "moTa", name: "moTa", label: "Mô tả", type: INPUT, css: css},
];
export {fields};
